import React, { useState, useCallback, useMemo } from "react";
import { Tooltip, Typography } from "@mui/material";

import { updateUser } from "../../../../sevices/apiUser";
import { objectToFormData } from "../../../../utils";
import { TooltipName } from "../../../../utils/Enums";
import FormDialog from "../../../../components/Dialog/FormDialog";
import useMutate from "../../../../hooks/useMutate";

function Logs({ logRequired, params }) {
  const [status, setStatus] = useState(logRequired);
  const [loading, setLoading] = useState(false);
  const [privatDialog, setPrivatDialog] = useState(false);

  const handleCloseDialog = useCallback(() => {
    setPrivatDialog(false);
  }, []);

  const { mutate } = useMutate(updateUser,["users"], 
    () => {},
     () => {
      setStatus((data) => !data);
      setLoading(false);
      handleCloseDialog();
    },
    () => {
      setLoading(false);
      handleCloseDialog();
    });

  const submitChangeWorklogStatus = useCallback(() => {
    const data = objectToFormData({ cardlog_required: !logRequired });
    setLoading(true);
    mutate({ id: params.row.user_id, data });
  }, [logRequired, params.row.user_id, mutate]);

  const tooltipTitle = useMemo(() => {
    return status
      ? TooltipName.MANAGE_USER.DISABLE_WORKLOG_TRACKING
      : TooltipName.MANAGE_USER.ENABLE_WORKLOG_TRACKING;
  }, [status]);

  const dialogMessage = useMemo(() => {
    return logRequired
      ? "Are you sure you want to disable the worklog status? Disabling it will stop tracking your current work activities."
      : "Are you sure you want to enable the worklog status?";
  }, [logRequired]);

  return (
    <>
      {privatDialog && (
        <FormDialog
          open={privatDialog}
          handleClose={() => setPrivatDialog(false)}
          handleSubmit={submitChangeWorklogStatus}
          loading={loading}
          buttonTxt={"Confirm"}
          title={"Confirmation: Change Worklog Status"}
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2">
            {dialogMessage}
          </Typography>
        </FormDialog>
      )}
      <Tooltip title={tooltipTitle}>
        <div className="w-100 d-flex justify-content-center">
          <label class="custom-checkbox">
            <input
              type="checkbox"
              checked={status}
              onClick={(event) => {
                setPrivatDialog(true);
              }}
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </Tooltip>
    </>
  );
}

const isChangeLogs = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.user_id === nextProps?.params?.row?.user_id
    && prevProps?.logRequired === nextProps?.logRequired
  );
};

export default React.memo(Logs, isChangeLogs);
